import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loadingLabel: {
		id: 'jql-builder-basic-picker.async-select.menu-list.load-more-trigger.loading-label',
		defaultMessage: 'Loading',
		description: 'Screen reader message on load of more filter options',
	},
});
